var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconF5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 71",
    enableBackground: "new 0 0 77 71",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1184A2",
    d: "M55.2,23.6c-6.9-0.9-13.5-6-16.3-8.4c-0.8-0.7-1.9-0.7-2.7,0c-2.8,2.4-9.4,7.6-16.3,8.4 c-1.1,0.1-1.9,1.1-1.9,2.2c0.9,21,14.6,30.2,18.5,32.4c0.6,0.4,1.4,0.4,2,0c3.9-2.2,17.7-11.4,18.5-32.4 C57.1,24.6,56.3,23.7,55.2,23.6z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 0.9 29.3925 46.7125)",
    fill: "#FFFFFF",
    fontFamily: "'Prompt-Light'",
    fontSize: "29.245px"
  }, "$")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconF5);
export default __webpack_public_path__ + "static/media/icon-f-5.0307b35474248827ae710c5882cb38ec.svg";
export { ForwardRef as ReactComponent };